var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "expand-y" } }, [
    _vm.currentReservationData && _vm.modifyBookingPropData
      ? _c(
          "div",
          {
            staticClass: "modify-detail component",
            class: [{ "multi-room": _vm.isMultiRoomReservation }],
          },
          [
            _c(
              "div",
              { staticClass: "modify-detail__header container" },
              [
                _vm.cancelReservationError
                  ? _c("div", { staticClass: "modify-detail__cancel-error" }, [
                      _c(
                        "div",
                        {
                          staticClass: "modify-detail__cancel-error-info-block",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "modify-detail__cancel-error-title",
                            },
                            [
                              _c("span", { staticClass: "cancel-icon" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.modifyReservationCancelErrorMessageTitle
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "modify-detail__cancel-error-message",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.cancelReservationErrorMessage) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "close-btn icon-close-v2",
                        on: {
                          click: _vm.closeCancelErrorMessage,
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.closeCancelErrorMessage($event)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.closeCancelErrorMessage($event)
                            },
                          ],
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("transition", { attrs: { name: "expand-y" } }, [
                  _vm.isMultiRoomReservation && _vm.selectedReservationsToCancel
                    ? _c(
                        "div",
                        { staticClass: "modify-detail__status-success cancel" },
                        _vm._l(
                          _vm.selectedReservationsToCancelItems,
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: "selectedReservationToCancel-" + item.id,
                                staticClass: "success-wrapper",
                              },
                              [
                                _c("span", { staticClass: "success-icon" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.ModifyReservationRoomTitle) +
                                      " #" +
                                      _vm._s(item.roomNumberOrder) +
                                      ":\n              " +
                                      _vm._s(item.roomStays[0].roomName) +
                                      "\n              " +
                                      _vm._s(
                                        _vm.ModifyReservationCancelRoomSuccessDescription
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.allReservationsAreCancelled &&
                !_vm.cancelReservationErrorMessage
                  ? _c("div", { staticClass: "modify-detail__status cancel" }, [
                      _c(
                        "div",
                        { staticClass: "modify-detail__status-info-block" },
                        [
                          _c(
                            "div",
                            { staticClass: "modify-detail__status-title" },
                            [
                              _c("span", { staticClass: "cancel-icon" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.ModifyReservationCancelTitle)
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("transition", { attrs: { name: "expand-y" } }, [
                  _vm.showReservationModifiedSuccess
                    ? _c(
                        "div",
                        { staticClass: "modify-detail__status-success modify" },
                        [
                          _c("div", { staticClass: "success-wrapper" }, [
                            _c("span", { staticClass: "success-icon" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.ModifyReservationConfirmationSuccessDescription
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modify-detail__header-back-to-lookup" },
                  [
                    !_vm.IsReservationMyStaysEntry
                      ? _c(
                          "a",
                          {
                            attrs: { href: _vm.ModifyReservationLookupPageUrl },
                          },
                          [_vm._v(_vm._s(_vm.ModifyReservationLookUp))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.IsReservationMyStaysEntry
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.ModifyReservationMyStaysPageUrl,
                            },
                          },
                          [_vm._v(_vm._s(_vm.ModifyReservationMemberDashboard))]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modify-detail__header-wrapper" }, [
                  _c("img", {
                    staticClass: "modify-detail__header-print-logo print-only",
                    attrs: {
                      src: _vm.propertyLogoImageSrc + "?fmt=png-alpha",
                      alt: _vm.propertyLogoImageAlt,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modify-detail__header-title-block" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "modify-detail__header-print-title print-only",
                        },
                        [_vm._v(_vm._s(_vm.PropertyName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modify-detail__header-title" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.ModifyReservationPageTitle) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "modify-detail__badge",
                          class: [
                            _vm.singleRoomStatus === "Committed"
                              ? "--committed"
                              : "--cancelled",
                          ],
                        },
                        [
                          _vm.singleRoomStatus === "Committed"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.tc(
                                      "booking.modifyReservationStatusConfirmed"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.singleRoomStatus === "Cancelled"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.tc(
                                      "booking.modifyReservationStatusCancelled"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "utility-actions-wrapper" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "modify-detail__badge",
                          class: [
                            _vm.singleRoomStatus === "Committed"
                              ? "--committed"
                              : "--cancelled",
                          ],
                        },
                        [
                          _vm.singleRoomStatus === "Committed"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.tc(
                                      "booking.modifyReservationStatusConfirmed"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.singleRoomStatus === "Cancelled"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.tc(
                                      "booking.modifyReservationStatusCancelled"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.allReservationsAreCancelled
                        ? _c("utility-actions")
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modify-detail__overview" }, [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c("div", { staticClass: "modify-detail__overview-hotel" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.PropertyName) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modify-detail__overview-wrapper" },
                    [
                      _vm.FanId
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "modify-detail__overview-member-info",
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.ModifyReservationMemberLabel)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modify-detail__overview-highlight",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.FanId) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modify-detail__overview-itinerary" },
                        [
                          !_vm.isMultiRoomReservation
                            ? _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.ModifyReservationItineraryTitle
                                    ) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm.isMultiRoomReservation
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.ModifyReservationItineraryTitle)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "modify-detail__overview-highlight",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.ModifyReservationItineraryNumber)
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "modify-detail__overview-confirmations",
                        },
                        _vm._l(_vm.sortedReservations, function (item, index) {
                          return _vm.currentReservationsList
                            ? _c(
                                "div",
                                {
                                  key: "sortedReservation-" + item.id,
                                  staticClass: "confirmation-number",
                                },
                                [
                                  _c("div", [
                                    _vm.isMultiRoomReservation
                                      ? _c("span", [
                                          _vm._v(
                                            "Room " +
                                              _vm._s(item.roomNumberOrder)
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status === "Committed"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ModifyReservationConfirmationTitle
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status === "Cancelled"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ModifyReservationCancellationDescription
                                            ) + " #"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "modify-detail__overview-highlight",
                                      },
                                      [_vm._v(_vm._s(item.id))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.ModifyReservationDateTitle) +
                                        "\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "modify-detail__overview-highlight",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getReservationDateRange(item)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "modify-detail__overview-property-details",
                          attrs: { tabindex: "0" },
                          on: {
                            click: _vm.togglePropertyMap,
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.togglePropertyMap($event)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.togglePropertyMap($event)
                              },
                            ],
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.ModifyReservationPropDetailsTitle) +
                              "\n            "
                          ),
                          _c("div", {
                            class: _vm.showPropertyMap
                              ? "icon-minus-white"
                              : "icon-add-white",
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "expand-y" } },
                    [
                      _vm.showPropertyMap
                        ? _c("modify-property-overview")
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modify-detail__main container",
                class: _vm.allReservationsAreCancelled ? "--allCancelled" : "",
              },
              [
                _c(
                  "div",
                  { staticClass: "modify-detail__reservations" },
                  [
                    _vm.allReservationsAreCancelled
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "modify-detail__reservation-cancelled-rooms-title",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.ModifyReservationCancelledRoomDescription
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      _vm.currentReservationsList,
                      function (reservation, index) {
                        return _c(
                          "div",
                          {
                            key:
                              reservation.id +
                              "-" +
                              reservation.roomStays[0].roomTypes[0]
                                .roomTypeCode,
                            staticClass: "modify-detail__reservation",
                            class:
                              reservation.status === "Cancelled"
                                ? "--cancelled"
                                : "",
                          },
                          [
                            reservation.status === "Cancelled" &&
                            index === _vm.firstCancelledIndex() &&
                            !_vm.allReservationsAreCancelled
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modify-detail__reservation-cancelled-rooms-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.ModifyReservationCancelledRoomDescription
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "modify-detail__room-image" },
                              [
                                _c(
                                  "picture",
                                  {
                                    directives: [
                                      {
                                        name: "lazyload",
                                        rawName: "v-lazyload",
                                        value: {
                                          src: _vm.roomImageSrc(reservation),
                                          set: [
                                            { height: "400", breakpoint: "xs" },
                                            { height: "600", breakpoint: "md" },
                                          ],
                                          fit: "crop",
                                          align: "center",
                                        },
                                        expression:
                                          "{\n                src: roomImageSrc(reservation),\n                set: [\n                  { height: '400', breakpoint: 'xs' },\n                  { height: '600', breakpoint: 'md' },\n                ],\n                fit: 'crop',\n                align: 'center',\n              }",
                                      },
                                    ],
                                    staticClass: "image-wrapper",
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "image modify-detail__image",
                                      attrs: {
                                        alt: _vm.roomImageSrcAlt(reservation),
                                        src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "modify-detail__room-info" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modify-detail__room-image print-only",
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "image modify-detail__image",
                                      attrs: {
                                        alt: _vm.roomImageSrcAlt(reservation),
                                        src: _vm.roomImageSrc(reservation),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "room-info-header" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "modify-detail__room-block",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "modify-detail__room-name",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.ModifyReservationRoomTitle
                                              ) +
                                              "\n                  " +
                                              _vm._s(
                                                reservation.roomNumberOrder
                                              ) +
                                              ":\n                  " +
                                              _vm._s(
                                                reservation.roomStays[0]
                                                  .roomName
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "modify-detail__badge",
                                      class: [
                                        reservation.status === "Committed"
                                          ? "--committed"
                                          : "--cancelled",
                                      ],
                                    },
                                    [
                                      reservation.status === "Committed"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.tc(
                                                  "booking.modifyReservationStatusConfirmed"
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      reservation.status === "Cancelled"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.tc(
                                                  "booking.modifyReservationStatusCancelled"
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "modify-detail__room-confirmation-block",
                                    },
                                    [
                                      reservation.status !== "Cancelled"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "modify-detail__room-confirmation",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.ModifyReservationConfirmationTitle
                                                  ) +
                                                  "\n                  " +
                                                  _vm._s(reservation.id) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      reservation.status === "Cancelled"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "modify-detail__room-confirmation",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.ModifyReservationConfirmationTitle
                                                  ) +
                                                  "\n                  " +
                                                  _vm._s(
                                                    _vm.getOriginalReservationId(
                                                      reservation
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      reservation.status === "Cancelled"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "modify-detail__cancellation-id",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.ModifyReservationCancellationDescription
                                                  ) +
                                                  " #\n                  " +
                                                  _vm._s(
                                                    _vm.getCancellationId(
                                                      reservation
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modify-detail__guest-rate-wrapper",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modify-detail__guest-header",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modify-detail__guest-title",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.ModifyReservationGuestInfoTitle
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modify-detail__guest-number",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  reservation.adultsCount
                                                ) +
                                                "\n                  "
                                            ),
                                            _vm.isGuestsPlural(
                                              reservation.adultsCount
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.tc(
                                                        "noums.adultPlural"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isGuestsPlural(
                                              reservation.adultsCount
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.tc(
                                                        "noums.adultSingular"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            reservation.childCount
                                              ? _c("span", [_vm._v(",")])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            reservation.childCount
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      reservation.childCount
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isGuestsPlural(
                                              reservation.childCount
                                            ) && reservation.childCount
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.tc(
                                                        "noums.childPlural"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isGuestsPlural(
                                              reservation.childCount
                                            ) && reservation.childCount
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.tc(
                                                        "noums.childSingular"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    reservation.guests[0]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modify-detail__guest_detail",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modify-detail__guest-name",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      reservation.guests[0]
                                                        .profiles.profileInfo
                                                        .profile.customer
                                                        .personName
                                                        .namePrefix[0] +
                                                        " " +
                                                        reservation.guests[0]
                                                          .profiles.profileInfo
                                                          .profile.customer
                                                          .personName
                                                          .givenName[0] +
                                                        " " +
                                                        reservation.guests[0]
                                                          .profiles.profileInfo
                                                          .profile.customer
                                                          .personName.surname
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modify-detail__guest-email",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      reservation.guests[0]
                                                        .profiles.profileInfo
                                                        .profile.customer.email
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modify-detail__guest-phone",
                                              },
                                              [
                                                _vm.phoneLocationType
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "+ " +
                                                          _vm._s(
                                                            _vm.phoneLocationType
                                                          ) +
                                                          "\n                    " +
                                                          _vm._s(
                                                            reservation
                                                              .guests[0]
                                                              .profiles
                                                              .profileInfo
                                                              .profile.customer
                                                              .telephone
                                                              .phoneNumber
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.phoneLocationType
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          reservation.guests[0]
                                                            .profiles
                                                            .profileInfo.profile
                                                            .customer.telephone
                                                            .phoneNumber
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            reservation.guests.length > 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "modify-detail__additional-guests",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modify-detail__guest-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.ModifyReservationAdditionalGuestFormTitle
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.additionalGuests(
                                                        reservation.guests
                                                      ),
                                                      function (guest, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              guest +
                                                              "-" +
                                                              index,
                                                            staticClass:
                                                              "modify-detail__guest-name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(guest) +
                                                                "\n                  "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                reservation.enhancementServices.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modify-detail-privileges -print print-only",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modify-detail-privileges__title",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.ModifyReservationCompPrivilegeTitle
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "modify-detail-privileges__items",
                                          },
                                          _vm._l(
                                            reservation.enhancementServices,
                                            function (item) {
                                              return reservation.enhancementServices
                                                ? _c(
                                                    "div",
                                                    {
                                                      key: item.synXisId,
                                                      staticClass:
                                                        "modify-detail-privileges__item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "modify-detail-privileges__content",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "modify-detail-privileges__heading",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    item.title
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  { attrs: { name: "expand-y" } },
                                  [
                                    _vm.showToggleRoom
                                      ? _c(
                                          "div",
                                          {
                                            class:
                                              "room-wrapper room-wrapper-" +
                                              index +
                                              " " +
                                              (_vm.isMultiRoomReservation &&
                                              reservation.status === "Cancelled"
                                                ? "-hidden"
                                                : ""),
                                          },
                                          [
                                            reservation.enhancementServices
                                              .length
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "modify-detail-privileges",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modify-detail-privileges__title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.ModifyReservationCompPrivilegeTitle
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modify-detail-privileges__items",
                                                      },
                                                      _vm._l(
                                                        reservation.enhancementServices,
                                                        function (item) {
                                                          return reservation.enhancementServices
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  key: item.synXisId,
                                                                  staticClass:
                                                                    "modify-detail-privileges__item",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "modify-detail-privileges__image-wrapper",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "picture",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "lazyload",
                                                                                rawName:
                                                                                  "v-lazyload",
                                                                                value:
                                                                                  {
                                                                                    src: item.imageSrc,
                                                                                    set: [
                                                                                      {
                                                                                        height:
                                                                                          "200",
                                                                                        breakpoint:
                                                                                          "xs",
                                                                                      },
                                                                                    ],
                                                                                    fit: "crop",
                                                                                    align:
                                                                                      "center",
                                                                                  },
                                                                                expression:
                                                                                  "{\n                            src: item.imageSrc,\n                            set: [{ height: '200', breakpoint: 'xs' }],\n                            fit: 'crop',\n                            align: 'center',\n                          }",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "image-wrapper",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "image modify-detail__image",
                                                                              attrs:
                                                                                {
                                                                                  alt: item.title,
                                                                                  src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "modify-detail-privileges__content",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "modify-detail-privileges__heading",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          " +
                                                                              _vm._s(
                                                                                item.title
                                                                              ) +
                                                                              "\n                        "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modify-detail__payment",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "modify-detail__payment-wrapper",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modify-detail__payment-method",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modify-detail__payment-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.ModifyReservationPaymentTitle
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.isDirectBill
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "modify-detail__payment-info",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "modify-detail__payment-type direct-bill",
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.tc(
                                                                            "booking.modifyDirectBillLabel"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "modify-detail__payment-info",
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "modify-detail__payment-logo",
                                                                  class:
                                                                    _vm.creditCard(
                                                                      reservation
                                                                    ).type,
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "modify-detail__payment-type",
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.tc(
                                                                            "booking.modifyCardEnd"
                                                                          )
                                                                        ) + " "
                                                                      ),
                                                                    ]),
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.creditCard(
                                                                          reservation
                                                                        ).number
                                                                      ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modify-detail__rate-taxes-block",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modify-detail__rate",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "best-rate-label",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "best-rate-label-name",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          reservation.ratePlanNameSynXis
                                                                        ) +
                                                                        "\n                          "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "best-rate-price-wrapper",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {},
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              _vm.avgPerNight(
                                                                                reservation
                                                                                  .prices
                                                                                  .avgPrice
                                                                              )
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "best-rate-avg-per-night",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              _vm.ModifyReservationRateAvgTitle
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "total-nights-rate",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "total-nights-rate__label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          reservation
                                                                            .prices
                                                                            .nightlyRates
                                                                            .length
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                    _vm.isNightPlural(
                                                                      reservation
                                                                    )
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.tc(
                                                                                  "noums.nightPlural"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.tc(
                                                                                  "noums.nightSingular"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "total-nights-rate__price",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.getDisplayPrice(
                                                                            {
                                                                              price:
                                                                                reservation
                                                                                  .roomStays[0]
                                                                                  .total
                                                                                  .amountBeforeTax,
                                                                              fromCurrency:
                                                                                _vm.currencyCode,
                                                                              toCurrency:
                                                                                _vm.orSelected(
                                                                                  _vm.currencyCode
                                                                                ),
                                                                              withIsoCode: true,
                                                                              isoAfter: true,
                                                                            }
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "toggle-details",
                                                                  {
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "default",
                                                                            fn: function (
                                                                              ref
                                                                            ) {
                                                                              var opened =
                                                                                ref.opened
                                                                              var toggle =
                                                                                ref.toggle
                                                                              var isMounted =
                                                                                ref.isMounted
                                                                              return _c(
                                                                                "div",
                                                                                {},
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "detailed-content",
                                                                                      class:
                                                                                        [
                                                                                          {
                                                                                            opened:
                                                                                              opened,
                                                                                          },
                                                                                        ],
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "activator",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "modify-detail__rate-toggle",
                                                                                              attrs:
                                                                                                {
                                                                                                  role: "button",
                                                                                                  tabindex:
                                                                                                    "0",
                                                                                                  "aria-expanded":
                                                                                                    opened
                                                                                                      ? "true"
                                                                                                      : "false",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  toggle,
                                                                                                keydown:
                                                                                                  [
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      if (
                                                                                                        !$event.type.indexOf(
                                                                                                          "key"
                                                                                                        ) &&
                                                                                                        _vm._k(
                                                                                                          $event.keyCode,
                                                                                                          "enter",
                                                                                                          13,
                                                                                                          $event.key,
                                                                                                          "Enter"
                                                                                                        )
                                                                                                      ) {
                                                                                                        return null
                                                                                                      }
                                                                                                      $event.preventDefault()
                                                                                                      return toggle(
                                                                                                        $event
                                                                                                      )
                                                                                                    },
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      if (
                                                                                                        !$event.type.indexOf(
                                                                                                          "key"
                                                                                                        ) &&
                                                                                                        _vm._k(
                                                                                                          $event.keyCode,
                                                                                                          "space",
                                                                                                          32,
                                                                                                          $event.key,
                                                                                                          [
                                                                                                            " ",
                                                                                                            "Spacebar",
                                                                                                          ]
                                                                                                        )
                                                                                                      ) {
                                                                                                        return null
                                                                                                      }
                                                                                                      $event.preventDefault()
                                                                                                      return toggle(
                                                                                                        $event
                                                                                                      )
                                                                                                    },
                                                                                                  ],
                                                                                              },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                      " +
                                                                                                      _vm._s(
                                                                                                        _vm.tc(
                                                                                                          "booking.modifyDetailsLabel"
                                                                                                        )
                                                                                                      ) +
                                                                                                      "\n                                    "
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  class:
                                                                                                    opened
                                                                                                      ? "icon-minus"
                                                                                                      : "icon-add",
                                                                                                }
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "print-only",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "modify-detail__rate-list",
                                                                                            },
                                                                                            _vm._l(
                                                                                              reservation
                                                                                                .prices
                                                                                                .nightlyRates,
                                                                                              function (
                                                                                                item,
                                                                                                index
                                                                                              ) {
                                                                                                return _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    key:
                                                                                                      item.date +
                                                                                                      "-" +
                                                                                                      index,
                                                                                                    staticClass:
                                                                                                      "modify-detail__rate-item",
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "modify-detail__rate-date",
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          "\n                                        " +
                                                                                                            _vm._s(
                                                                                                              _vm.bestRateDate(
                                                                                                                item.date
                                                                                                              )
                                                                                                            ) +
                                                                                                            "\n                                      "
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                    _vm._v(
                                                                                                      " "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "modify-detail__rate-price",
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          "\n                                        " +
                                                                                                            _vm._s(
                                                                                                              _vm.getDisplayPrice(
                                                                                                                {
                                                                                                                  price:
                                                                                                                    item.price,
                                                                                                                  fromCurrency:
                                                                                                                    _vm.currencyCode,
                                                                                                                  toCurrency:
                                                                                                                    _vm.orSelected(
                                                                                                                      _vm.currencyCode
                                                                                                                    ),
                                                                                                                  withIsoCode: true,
                                                                                                                  isoAfter: true,
                                                                                                                }
                                                                                                              )
                                                                                                            ) +
                                                                                                            "\n                                      "
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              }
                                                                                            ),
                                                                                            0
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "modify-detail__rate-group",
                                                                                          class:
                                                                                            {
                                                                                              opened:
                                                                                                opened,
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          opened
                                                                                            ? _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "modify-detail__rate-list",
                                                                                                },
                                                                                                _vm._l(
                                                                                                  reservation
                                                                                                    .prices
                                                                                                    .nightlyRates,
                                                                                                  function (
                                                                                                    item,
                                                                                                    index
                                                                                                  ) {
                                                                                                    return _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        key:
                                                                                                          item.date +
                                                                                                          "-" +
                                                                                                          index,
                                                                                                        staticClass:
                                                                                                          "modify-detail__rate-item",
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "modify-detail__rate-date",
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "\n                                        " +
                                                                                                                _vm._s(
                                                                                                                  _vm.bestRateDate(
                                                                                                                    item.date
                                                                                                                  )
                                                                                                                ) +
                                                                                                                "\n                                      "
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "modify-detail__rate-price",
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "\n                                        " +
                                                                                                                _vm._s(
                                                                                                                  _vm.getDisplayPrice(
                                                                                                                    {
                                                                                                                      price:
                                                                                                                        item.price,
                                                                                                                      fromCurrency:
                                                                                                                        _vm.currencyCode,
                                                                                                                      toCurrency:
                                                                                                                        _vm.orSelected(
                                                                                                                          _vm.currencyCode
                                                                                                                        ),
                                                                                                                      withIsoCode: true,
                                                                                                                      isoAfter: true,
                                                                                                                    }
                                                                                                                  )
                                                                                                                ) +
                                                                                                                "\n                                      "
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                      ]
                                                                                                    )
                                                                                                  }
                                                                                                ),
                                                                                                0
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modify-detail__add-ons",
                                                          },
                                                          [
                                                            reservation.addOns &&
                                                            reservation.addOns
                                                              .length > 0
                                                              ? _c(
                                                                  "add-ons-overview",
                                                                  {
                                                                    attrs: {
                                                                      "add-ons":
                                                                        reservation.addOns,
                                                                      "currency-code":
                                                                        _vm.currencyCode,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modify-detail__taxes",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "modify-detail__taxes-header",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "modify-detail__taxes-label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.ModifyReservationTaxesTitle
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "modify-detail__taxes-total",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              _vm.calculateRoomTotalTaxesFees(
                                                                                reservation
                                                                              )
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "modify-detail__taxes-add-ons",
                                                                  },
                                                                  [
                                                                    reservation.addOns &&
                                                                    reservation
                                                                      .addOns
                                                                      .length >
                                                                      0
                                                                      ? _c(
                                                                          "add-ons-taxes-overview",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "add-ons":
                                                                                  reservation.addOns,
                                                                                "currency-code":
                                                                                  _vm.currencyCode,
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "toggle-details",
                                                                  {
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "default",
                                                                            fn: function (
                                                                              ref
                                                                            ) {
                                                                              var opened =
                                                                                ref.opened
                                                                              var toggle =
                                                                                ref.toggle
                                                                              var isMounted =
                                                                                ref.isMounted
                                                                              return _c(
                                                                                "div",
                                                                                {},
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "detailed-content",
                                                                                      class:
                                                                                        [
                                                                                          {
                                                                                            opened:
                                                                                              opened,
                                                                                          },
                                                                                        ],
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "activator",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "modify-detail__taxes-toggle",
                                                                                              attrs:
                                                                                                {
                                                                                                  role: "button",
                                                                                                  tabindex:
                                                                                                    "0",
                                                                                                  "aria-expanded":
                                                                                                    opened
                                                                                                      ? "true"
                                                                                                      : "false",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  toggle,
                                                                                                keydown:
                                                                                                  [
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      if (
                                                                                                        !$event.type.indexOf(
                                                                                                          "key"
                                                                                                        ) &&
                                                                                                        _vm._k(
                                                                                                          $event.keyCode,
                                                                                                          "enter",
                                                                                                          13,
                                                                                                          $event.key,
                                                                                                          "Enter"
                                                                                                        )
                                                                                                      ) {
                                                                                                        return null
                                                                                                      }
                                                                                                      $event.preventDefault()
                                                                                                      return toggle(
                                                                                                        $event
                                                                                                      )
                                                                                                    },
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      if (
                                                                                                        !$event.type.indexOf(
                                                                                                          "key"
                                                                                                        ) &&
                                                                                                        _vm._k(
                                                                                                          $event.keyCode,
                                                                                                          "space",
                                                                                                          32,
                                                                                                          $event.key,
                                                                                                          [
                                                                                                            " ",
                                                                                                            "Spacebar",
                                                                                                          ]
                                                                                                        )
                                                                                                      ) {
                                                                                                        return null
                                                                                                      }
                                                                                                      $event.preventDefault()
                                                                                                      return toggle(
                                                                                                        $event
                                                                                                      )
                                                                                                    },
                                                                                                  ],
                                                                                              },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "details",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                      " +
                                                                                                      _vm._s(
                                                                                                        _vm.tc(
                                                                                                          "booking.modifyDetailsLabel"
                                                                                                        )
                                                                                                      ) +
                                                                                                      "\n                                    "
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  class:
                                                                                                    opened
                                                                                                      ? "icon-minus"
                                                                                                      : "icon-add",
                                                                                                }
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "print-only",
                                                                                        },
                                                                                        [
                                                                                          _vm._l(
                                                                                            _vm.sumUniqueTaxCodes(
                                                                                              reservation
                                                                                                .total
                                                                                                .taxesFees
                                                                                            ),
                                                                                            function (
                                                                                              item,
                                                                                              index
                                                                                            ) {
                                                                                              return _c(
                                                                                                "div",
                                                                                                {
                                                                                                  key:
                                                                                                    "taxes-print-" +
                                                                                                    item.code +
                                                                                                    "-" +
                                                                                                    index,
                                                                                                  staticClass:
                                                                                                    "modify-detail__taxes-list",
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "modify-detail__taxes-item",
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "modify-detail__taxes-name",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "\n                                        " +
                                                                                                              _vm._s(
                                                                                                                item.description
                                                                                                              ) +
                                                                                                              "\n                                      "
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "modify-detail__taxes-amount",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "\n                                        " +
                                                                                                              _vm._s(
                                                                                                                _vm.getDisplayPrice(
                                                                                                                  {
                                                                                                                    price:
                                                                                                                      item.price,
                                                                                                                    fromCurrency:
                                                                                                                      _vm.currencyCode,
                                                                                                                    toCurrency:
                                                                                                                      _vm.orSelected(
                                                                                                                        _vm.currencyCode
                                                                                                                      ),
                                                                                                                    withIsoCode: true,
                                                                                                                    isoAfter: true,
                                                                                                                  }
                                                                                                                )
                                                                                                              ) +
                                                                                                              "\n                                      "
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _vm.addOnsTotalTaxes(
                                                                                            reservation.addOns
                                                                                          ) >
                                                                                          0
                                                                                            ? _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "modify-detail__taxes-list",
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "modify-detail__taxes-item",
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "modify-detail__taxes-name",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "\n                                        " +
                                                                                                              _vm._s(
                                                                                                                _vm.addonTaxesTotalLabel
                                                                                                              ) +
                                                                                                              "\n                                      "
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "modify-detail__taxes-amount",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "\n                                        " +
                                                                                                              _vm._s(
                                                                                                                _vm.getDisplayPrice(
                                                                                                                  {
                                                                                                                    price:
                                                                                                                      _vm.addOnsTotalTaxes(
                                                                                                                        reservation.addOns
                                                                                                                      ),
                                                                                                                    fromCurrency:
                                                                                                                      _vm.currencyCode,
                                                                                                                    toCurrency:
                                                                                                                      _vm.orSelected(
                                                                                                                        _vm.currencyCode
                                                                                                                      ),
                                                                                                                    withIsoCode: true,
                                                                                                                    isoAfter: true,
                                                                                                                  }
                                                                                                                )
                                                                                                              ) +
                                                                                                              "\n                                      "
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ],
                                                                                        2
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "modify-detail__taxes-group",
                                                                                          class:
                                                                                            {
                                                                                              opened:
                                                                                                opened,
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "transition-group",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  name: "expand-y",
                                                                                                },
                                                                                            },
                                                                                            _vm._l(
                                                                                              _vm.sumUniqueTaxCodes(
                                                                                                reservation
                                                                                                  .total
                                                                                                  .taxesFees
                                                                                              ),
                                                                                              function (
                                                                                                item,
                                                                                                index
                                                                                              ) {
                                                                                                return opened
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        key:
                                                                                                          "taxes-" +
                                                                                                          item.code,
                                                                                                        staticClass:
                                                                                                          "modify-detail__taxes-list",
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "modify-detail__taxes-item",
                                                                                                          },
                                                                                                          [
                                                                                                            _c(
                                                                                                              "div",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "modify-detail__taxes-name",
                                                                                                              },
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "\n                                          " +
                                                                                                                    _vm._s(
                                                                                                                      item.description
                                                                                                                    ) +
                                                                                                                    "\n                                        "
                                                                                                                ),
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "div",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "modify-detail__taxes-amount",
                                                                                                              },
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "\n                                          " +
                                                                                                                    _vm._s(
                                                                                                                      _vm.getDisplayPrice(
                                                                                                                        {
                                                                                                                          price:
                                                                                                                            item.price,
                                                                                                                          fromCurrency:
                                                                                                                            _vm.currencyCode,
                                                                                                                          toCurrency:
                                                                                                                            _vm.orSelected(
                                                                                                                              _vm.currencyCode
                                                                                                                            ),
                                                                                                                          withIsoCode: true,
                                                                                                                          isoAfter: true,
                                                                                                                        }
                                                                                                                      )
                                                                                                                    ) +
                                                                                                                    "\n                                        "
                                                                                                                ),
                                                                                                              ]
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e()
                                                                                              }
                                                                                            ),
                                                                                            0
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.isMultiRoomReservation
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modify-detail__payment-total-wrapper",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modify-detail__total-label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.ModifyReservationRoomTotalTitle
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modify-detail__total-price",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.getRoomTotalPerRoom(
                                                                    reservation
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                reservation.status === "Cancelled" &&
                                _vm.isMultiRoomReservation
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modify-detail__reservation-room-details-toggle",
                                        class:
                                          "modify-detail__reservation-room-details-toggle-" +
                                          index +
                                          " " +
                                          (_vm.isMultiRoomReservation
                                            ? "multi-room"
                                            : ""),
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleCancelledRoom(
                                              index
                                            )
                                          },
                                          keydown: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "space",
                                                  32,
                                                  $event.key,
                                                  [" ", "Spacebar"]
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.toggleCancelledRoom(
                                                index
                                              )
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.toggleCancelledRoom(
                                                index
                                              )
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "title -hide",
                                            attrs: { tabindex: "0" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ModifyReservationHideDetailsDescription
                                              ) + "\n                "
                                            ),
                                            _c("div", {
                                              staticClass: "icon-minus",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "title -show",
                                            attrs: { tabindex: "0" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.ModifyReservationShowDetailsDescription
                                              ) + "\n                "
                                            ),
                                            _c("div", {
                                              staticClass: "icon-add",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm.showToggleRoom
                      ? _c(
                          "div",
                          {
                            staticClass: "modify-detail__payment-total-wrapper",
                            class: [
                              _vm.isMultiRoomReservation ? "--grandTotal" : "",
                            ],
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "modify-detail__total-label" },
                              [
                                !_vm.isMultiRoomReservation
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.ModifyReservationTotalTitle)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isMultiRoomReservation
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.ModifyReservationGrandTotalTitle
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "modify-detail__total-price" },
                              [
                                !_vm.isMultiRoomReservation
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.singleRoomtotal)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isMultiRoomReservation
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.multiRoomTotal)),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allReservationsAreCancelled &&
                    !_vm.isMultiRoomReservation
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "modify-detail__reservation-room-details-toggle",
                            class: !_vm.showToggleRoom ? "-closed" : "",
                            on: {
                              click: function ($event) {
                                _vm.showToggleRoom = !_vm.showToggleRoom
                              },
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  _vm.showToggleRoom = !_vm.showToggleRoom
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  _vm.showToggleRoom = !_vm.showToggleRoom
                                },
                              ],
                            },
                          },
                          [
                            _c("span", { staticClass: "title -hide" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.ModifyReservationHideDetailsDescription
                                ) + "\n            "
                              ),
                              _c("div", { staticClass: "icon-minus" }),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "title -show" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.ModifyReservationShowDetailsDescription
                                ) + "\n            "
                              ),
                              _c("div", { staticClass: "icon-add" }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modify-detail__sidebar" },
                  [
                    _c("div", { staticClass: "print-only" }, [
                      _c(
                        "div",
                        { staticClass: "modify-room-overview -itinerary" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "modify-detail__overview-itinerary",
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.ModifyReservationItineraryTitle
                                    ) +
                                    "\n                "
                                ),
                                _c("span", [_vm._v(":")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modify-detail__overview-highlight",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.ModifyReservationItineraryNumber
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "modify-detail__overview-confirmations",
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.ModifyReservationConfirmationTitle)
                                ),
                                _c("span", [_vm._v(":")]),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.currentReservationsList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "confirmation-" + item.id,
                                      staticClass: "confirmation-number",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "modify-detail__overview-highlight",
                                        },
                                        [
                                          _vm.isMultiRoomReservation
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.ModifyReservationRoomTitle
                                                    ) +
                                                    "\n                    " +
                                                    _vm._s(
                                                      item.roomNumberOrder
                                                    ) +
                                                    ": "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(_vm._s(item.id)),
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(
                      _vm.filteredReservationsByDateRange,
                      function (reservations, index) {
                        return _c("modify-room-overview", {
                          key: "room-overview-" + index,
                          attrs: { reservations: reservations },
                        })
                      }
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "print-only" }, [
                      _c(
                        "div",
                        {
                          staticClass: "modify-room-overview -property-details",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "modify-detail__overview-property-details",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.ModifyReservationPropDetailsTitle
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("modify-property-overview"),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.showDefaultModifyAndCancelMessage
                        ? _c(
                            "div",
                            { staticClass: "modify-room-overview -policies" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modify-room-overview__policies-title",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.ModifyReservationPoliciesTitle
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modify-room-overview__policies-list",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "modify-room-overview__policies-label",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.ModifyReservationGuaranteePolicyTitle
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ul", {
                                    class:
                                      "modify-room-overview__policies-content " +
                                      _vm.indentGuaranteePolicyHtmMarkup,
                                    domProps: {
                                      innerHTML: _vm._s(_vm.guaranteePolicy),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "modify-room-overview__policies-label",
                                    },
                                    [
                                      _vm.isMultiRoomReservation
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cancelReservationPolicyLabelPlural
                                              )
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cancelReservationPolicyLabelSingular
                                              )
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.currentReservationsList,
                                    function (reservation) {
                                      return _c(
                                        "div",
                                        {
                                          key: "policy-print-" + reservation.id,
                                          staticClass:
                                            "cancel-item list-indent",
                                        },
                                        [
                                          _vm.isMultiRoomReservation
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.ModifyReservationRoomTitle
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      reservation.roomNumberOrder
                                                    ) +
                                                    ":\n                  " +
                                                    _vm._s(
                                                      reservation.roomStays[0]
                                                        .roomName
                                                    ) +
                                                    "\n                "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "modify-room-overview__policies-content",
                                            },
                                            [
                                              _c("li", [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.renderCancelPenaltiesText(
                                                        reservation.cancelPenaltiesText
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDefaultModifyAndCancelMessage
                        ? _c(
                            "div",
                            { staticClass: "modify-room-overview -policies" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modify-room-overview__policies-title",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.ModifyReservationPoliciesTitle
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("ul", {
                                class:
                                  "modify-room-overview__policies-content " +
                                  _vm.indentGuaranteePolicyHtmMarkup,
                                domProps: {
                                  innerHTML: _vm._s(_vm.guaranteePolicy),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modify-room-overview__policies-label",
                                },
                                [
                                  _vm.isMultiRoomReservation
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.cancelReservationPolicyLabelPlural
                                          )
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.cancelReservationPolicyLabelSingular
                                          )
                                        ),
                                      ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modify-room-overview__policies-list",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "modify-room-overview__policies-content remove-indent",
                                    },
                                    _vm._l(
                                      _vm.currentReservationsList,
                                      function (reservation) {
                                        return _c(
                                          "div",
                                          {
                                            key: "policy-" + reservation.id,
                                            staticClass: "policy-item",
                                            class: [
                                              {
                                                single:
                                                  !_vm.isMultiRoomReservation,
                                              },
                                            ],
                                          },
                                          [
                                            _vm.isMultiRoomReservation
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "policy-room-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.ModifyReservationRoomTitle
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          reservation.roomNumberOrder
                                                        ) +
                                                        ":\n                    " +
                                                        _vm._s(
                                                          reservation
                                                            .roomStays[0]
                                                            .roomName
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("ul", {
                                              staticClass:
                                                "policy-description list-indent",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.renderCancelPenaltiesText(
                                                    reservation.cancelPenaltiesText
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("modifyChangeActions"),
                  ],
                  2
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }